import React from "react";
import { IoCloseSharp, IoTrash } from "react-icons/io5";
import { formatToINR, getFileUrl } from "../../../utils/helper";
import { useDispatch } from "react-redux";
import { removeFromWishlist } from "../../../store/slice/userActions";
import placeHolderImage from "../../../assets/images/placeholder/product.jpg";
const WishlistItem = ({ item }) => {
  const dispatch = useDispatch();

  const mainImage =
    item?.product?.image ??
    placeHolderImage;

  const handleRemove = () => {
    dispatch(removeFromWishlist(item?.product?._id));
  };
  return (
    <div className="py-2 border-b">
      <div className="flex items-center justify-between px-2 ">
        <div className="flex items-center gap-2">
          <img
            src={getFileUrl(mainImage)}
            height={50}
            width={50}
            alt={item?.product?.name}
            className="border rounded"
          />
          <div className="flex flex-col gap-1">
            <p className="font-[450] justify-self-start">
              {item?.product?.name}
            </p>
            <p>
              {formatToINR(item?.product?.finalPrice?.toFixed(2))}
              <span className="font-semibold"></span>
            </p>
          </div>
        </div>
        <div className=" flex items-end flex-col gap-1">
          <button className="bg-red-100 hover:text-white hover:bg-red-500 p-2 rounded-full">
            <IoTrash
              className="text-lg text-red-500 hover:text-white cursor-pointer"
              onClick={handleRemove}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default WishlistItem;
